import { emojifyHtml } from "./appleEmoji";
import DOMPurify from "dompurify";

/** Replace links with «کلیک کنید» styled like old front */
export function replaceLinksWithClickText(htmlContent) {
  if (!htmlContent) return "";
  // [متن دکمه](لینک) → همان متن دکمه
  let processed = String(htmlContent).replace(
    /\[([^\]\n]{1,60})\]\((https?:\/\/[^\s)<>"]+)\)/g,
    (_m, label) => `<span class="mention-symbol">${label.trim().replace(/</g, "&lt;")}</span>`
  );
  processed = processed.replace(
    /<a\b[^>]*href=(['"]?)([^"'\s>]+)\1[^>]*>[\s\S]*?<\/a>/gi,
    '<span class="mention-symbol">کلیک کنید</span>'
  );
  processed = processed.replace(
    /(^|[^"'>])(https?:\/\/[^\s<>"]+)/gi,
    '$1<span class="mention-symbol">کلیک کنید</span>'
  );
  return processed;
}

/** Replace quickchat action tokens with blue clickable-looking label */
export function replaceQuickChatTokensForListPreview(content) {
  if (!content) return "";
  return String(content).replace(
    /@([a-z0-9-]+)\s*(\{[\s\S]*?\})\s*\[([^\]]+)\]/gi,
    (_, _slug, _payload, label) =>
      `<span class="mention-symbol quickchat-preview-action">${String(label || "").trim()}</span>`
  );
}

/** Format preview HTML with mentions and links styled (matches old front TicketList getFirstTwoLines) */
export function formatPreviewForList(htmlContent) {
  if (!htmlContent) return { html: "", isPlain: false };
  let processed = replaceQuickChatTokensForListPreview(htmlContent)
    .replace(/\[QUOTE_USER\]([\s\S]*?)\[\/QUOTE_USER\]/g, (_, c) => {
      const t = (c || "").replace(/<[^>]*>/g, "").trim();
      return t ? `کاربر: ${t}` : "";
    })
    .replace(/\[QUOTE_AI\]([\s\S]*?)\[\/QUOTE_AI\]/g, (_, c) => {
      const t = (c || "").replace(/<[^>]*>/g, "").trim();
      return t ? `هوش مصنوعی: ${t}` : "";
    })
    .replace(/\[QUOTE_WARNING\]([\s\S]*?)\[\/QUOTE_WARNING\]/g, (_, c) => {
      const t = (c || "").replace(/<[^>]*>/g, "").trim();
      return t ? `⚠️ توجه: ${t}` : "";
    });
  processed = replaceLinksWithClickText(processed);
  processed = processed.replace(
    /@\[([^\]]+)\]\(user:\d+\)/g,
    '<span class="mention-symbol">@$1</span>'
  );
  processed = processed
    .replace(/<\/?(p|div)[^>]*>/gi, " ")
    .replace(/<br\s*\/?>/gi, " ")
    .replace(/\s+/g, " ")
    .trim();
  const div = document.createElement("div");
  div.innerHTML = processed;
  let text = (div.textContent || "").replace(/\s+/g, " ").trim();
  const maxLen = 180;
  if (text.length > maxLen) {
    const cutPoint = Math.max(0, text.slice(0, maxLen).lastIndexOf(" ") || maxLen);
    const truncDiv = document.createElement("div");
    truncDiv.innerHTML = processed;
    const walker = document.createTreeWalker(truncDiv, NodeFilter.SHOW_TEXT, null, false);
    let len = 0;
    let node;
    while ((node = walker.nextNode())) {
      const nodeLen = (node.textContent || "").length;
      if (len + nodeLen > cutPoint) {
        node.textContent = (node.textContent || "").slice(0, cutPoint - len);
        let n;
        while ((n = walker.nextNode())) {
          if (n.parentNode) n.parentNode.removeChild(n);
        }
        break;
      }
      len += nodeLen;
    }
    processed = truncDiv.innerHTML;
  }

  const sanitized = DOMPurify.sanitize(processed, {
    ALLOWED_TAGS: ["span", "strong", "b", "em", "i", "u"],
    ALLOWED_ATTR: ["class"],
  });
  return { html: emojifyHtml(sanitized), isPlain: false };
}

export function getPreview(html, maxLen = 80) {
  if (!html) return "";
  const div = document.createElement("div");
  div.innerHTML = html;
  const text = (div.textContent || "").replace(/\s+/g, " ").trim();
  return text.length > maxLen ? `${text.slice(0, maxLen)}…` : text;
}

/** Plain-text preview with mention/link/token replacements applied (for compact lists). */
export function getChatListPreviewPlainText(htmlContent, maxLen = 72) {
  if (!htmlContent) return "";
  const { html } = formatPreviewForList(htmlContent);
  if (html) return getPreview(html, maxLen);
  return getPreview(htmlContent, maxLen);
}
